import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TP_ALL_SECTIONS} from '@doctor-panel-modules/patient-treatment-plan/models/tp-sections-info';

@Component({
  selector: 'app-assistant-text-modal',
  templateUrl: './assistant-text-modal.component.html',
  styleUrls: ['./assistant-text-modal.component.scss'],
  standalone: false
})
export class AssistantTextModalComponent implements OnInit {

  formattedText: string | null = null;
  TP_SECTIONS_INFO = TP_ALL_SECTIONS;

  constructor(
    public dialogRef: MatDialogRef<AssistantTextModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    const rawText = this.data?.data?.assistantResponse?.content?.text;
    if (rawText) {
      // sostituisco punto + spazio con punto + <br/>
      this.formattedText = rawText.replace(/\.\s/g, '.<br/>');
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
